module.exports = __webpack_public_path__ + "img/flag-Fr.7f088a8b.png";